import { create } from 'zustand';
import { type components } from '../endpoint/Schema';
import OpenAPI from '../endpoint/Openapi';
import useTenantStore from './TenantStore';

type ITopic = components['schemas']['FaqTopicDto'];

interface IFAQStore {
  topics: ITopic[];

  fetchTopics: () => Promise<void>;
  setTopics: (topics: ITopic[]) => void;
  updateTopic: (topic: ITopic) => void;
  disableFAQ: (topicId?: string, faqId?: string) => void;
  deleteFAQ: (topicId?: string, faqId?: string) => void;
}

const useFAQStore = create<IFAQStore>((set) => ({
  topics: [],
  fetchTopics: async () => {
    try {
      const res = await OpenAPI.GET('/api/v2/admin/faq/topic', {
        params: { query: { tenantId: useTenantStore.getState().id } },
      });

      if (res.data && res.response.ok) {
        set({ topics: res.data });
      }
    } catch (err) {
      // error
    }
  },
  setTopics: (topics: ITopic[]) => {
    set({ topics });
  },
  updateTopic: (topic: ITopic) => {
    set((state) => ({
      topics: state.topics.map((item) =>
        item.id === topic.id ? { ...item, ...topic } : item,
      ),
    }));
  },
  disableFAQ: (topicId?: string, faqId?: string) => {
    set((state) => ({
      topics: state.topics.map((item) =>
        item.id === topicId
          ? {
              ...item,
              faq: item.faq?.map((faq) =>
                faq.id === faqId ? { ...faq, enabled: !faq.enabled } : faq,
              ),
            }
          : item,
      ),
    }));
  },
  deleteFAQ: (topicId?: string, faqId?: string) => {
    set((state) => ({
      topics: state.topics.map((item) =>
        item.id === topicId
          ? {
              ...item,
              faq: item.faq?.filter((faq) => faq.id !== faqId), // Remove the FAQ
            }
          : item,
      ),
    }));
  },
}));

export default useFAQStore;

export const selectQuestions = (state: IFAQStore, topicId?: string) => {
  return state.topics.find((topic) => topic.id === topicId)?.faq;
};

export const selectTopicName = (state: IFAQStore, id?: string) => {
  return state.topics.find((topic) => topic.id === id)?.name ?? '';
};
